import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core';

@Directive({
    selector: '[restrictCopyPaste]'
})
export class RestrictCopyPasteDirective {

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    // Disable paste event
    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent): void {
        event.preventDefault();  // Prevent paste functionality
        // alert("Copy-Paste is disabled in this field!");
    }

    // Disable cut event (optional, if you want to also restrict cutting text)
    @HostListener('cut', ['$event'])
    onCut(event: ClipboardEvent): void {
        event.preventDefault();  // Prevent cut functionality
        // alert("Copy-Paste is disabled in this field!");
    }

    // Optional: Disable context menu (right-click)
    @HostListener('contextmenu', ['$event'])
    onContextMenu(event: MouseEvent): void {
        event.preventDefault(); // Disable right-click
        // alert("Copy-Paste is disabled in this field!");
    }
}
